import { render, staticRenderFns } from "./PortingProcessDashboardPopup.vue?vue&type=template&id=34848878&scoped=true&"
import script from "./PortingProcessDashboardPopup.vue?vue&type=script&lang=js&"
export * from "./PortingProcessDashboardPopup.vue?vue&type=script&lang=js&"
import style0 from "./PortingProcessDashboardPopup.vue?vue&type=style&index=0&id=34848878&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34848878",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VChip,VDataTable,VSpacer,VToolbar,VToolbarTitle})
